<template>
    <div class="occasion-filter">
        <div @click="collapse" class="title-container">
            <p class="title">Card Type <span v-if="selectedOccasion.length > 0">({{selectedOccasion.length}})</span></p>
            <p class="icon">{{plusIcon}}</p>
        </div>
        <div v-if="!collapsed" class="radio-container">
            <div @click="setSelectedOccasion(occasion)" class="radio-button" v-for="occasion of occasions" :key="occasion">
                <input :checked="selectedOccasion.includes(occasion)" :value="occasion" type="checkbox">
                <p>{{occasion}}</p>
            </div>
        </div>
  </div>
  </template>
  
  <script>
  import smoothReflow from 'vue-smooth-reflow'
  import { mapGetters } from 'vuex';
  export default {
        mixins: [smoothReflow],
        data() {
            return{
                collapsed: false,
            }
        },
        props:{
            occasions: Array,
        },
        computed: {
            selectedOccasion: {
                get(){ return this.$store.state.selectedCardsOccasionsMobile},
                set(value){
                }
            },
            plusIcon(){
                return this.collapsed == true ? '+' : '-';
            }
        },
        methods: {
            setSelectedOccasion(value){
                this.$store.commit('setSelectedCardsOccasionsMobile', value )
            },
            collapse(){
                this.collapsed = !this.collapsed;
            },
        },
        mounted(){
            this.$smoothReflow()
        },
  }
  </script>
  
  <style scoped>
    .occasion-filter{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background-color: white;
        box-shadow: inset 0px -1px 0px #E6E8EC;
    }
  
    .icon{
        cursor: pointer;
        font-size: 1rem;
    }
  
    .title-container{
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        padding: 2% 5%;
    }
    .title{
        color: #0F0C38;
        font-family: 'Karla';
        font-style: normal;
        font-weight: 700;
        font-size: 1.3vw;
        line-height: 1.5;
    }
  
  .radio-container{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0% 0% 3% 5%;
      width: 100%;
      overflow: hidden;
  }
  
  .radio-button{
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 1% 0%;
  }
  
  .radio-button input{
      background-color: #FFFFFF;
      border: 1px solid #E8E1F2;
      box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
      border-radius: 40px;
      height: unset !important;
  }
  
  .radio-button p{
      font-family: 'Karla';
      font-style: normal;
      font-weight: 400;
      font-size: 1.2vw;
      line-height: 1.43;
      color: #0F0C38;
  }

    .filter-header{
        width: 100%;
        display: flex;
        gap: 2%;
        font-size: 1.15vw;
        align-items: center;
    }

    .filter-header img{
        width: 10%;
        transition: all 0.5s linear;
    }

    .filter-header .flipped{
        transform: rotate(180deg);
    }

    .filter-header p{
        width: 80%;
        font-weight: bold;
    }
  
  @media screen and (max-width: 767px){
      .title{
          font-size: 1.2rem;
      }
  
      .icon{
          font-size: 2rem;
      }
  
      .radio-button p{
          font-size: 1rem;
      }
  }
  </style>